<script lang="ts">
  import NavItem from "$routes/(microsites)/gpu-glossary/_components/NavItem.svelte";
  import type { Page } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
  import { themeStore } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";

  export let contents: Page[];
</script>

<div class="py-6">
  <div class="flex flex-col gap-y-2" style:color={$themeStore.primary[80]}>
    {#each contents as section}
      <NavItem {section} showArrow={true} />
    {/each}
  </div>
</div>
